import clsx from "clsx";

const BenefitCard = ({ title, values, classNames }) => {
    return (
        <div className={clsx(
            "flex flex-col phone:pt-[24px] phone:!pb-[24px] space-y-2 items-center md:pl-2",
            classNames
        )}>
            <h1 className="font-medium text-heading-4 text-neutral-100 tablet:text-heading-5 leading-[42px] tracking-text-sm">{values}</h1>
            <p className="text-md font-normal text-neutral-50 tracking-text-sm leading-[27.2px]">{title}</p>
        </div>
    );
};

export default BenefitCard;